import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Error from "../components/Error";
import { useGoToPage } from "../function/functions";
import secureLocalStorage from "react-secure-storage";
import Navbar from "../components/Navbar";
import { API_BASE_URL } from "../config/ApisCollection";

const CallBackPayment = () => {
  const { getTranId } = useParams();
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [timerStatus, setTimerStatus] = useState(null);
  const goToPage = useGoToPage();
  const [timer, setTimer] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (timer === 0 && timerStatus) {
      if (successMsg) {
        if (
          secureLocalStorage.getItem("userEmail") &&
          secureLocalStorage.getItem("finalData")
        ) {
          goToPage(null, null, "user-registration");
        } else {
          goToPage(null, null, "thank-you");
        }
      } else {
        goToPage(null, null, "priceplan");
      }
    }
    if (localStorage.getItem("remainingTime")) {
      localStorage.removeItem("remainingTime");
    }
  }, [timer, getTranId, goToPage]);

  useEffect(() => {
    if (getTranId) {
      statusValidator(getTranId);
    } else {
      goToPage(null, null, "priceplan");
    }
  }, [getTranId]);

  const statusValidator = async (tranId) => {
    const get_options = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let validator_url =
      API_BASE_URL + "/pro/p3/pg/merchant/statusvalidator/web/";
    if (secureLocalStorage.getItem("gateway") == "linkq") {
      validator_url =
        API_BASE_URL + "/pro/p4/linkq/merchant/statusvalidator/web/";
    }

    try {
      const response = await axios.get(validator_url + tranId, get_options);
      if (response) {
        setTimerStatus(true);
      }

      if (response.data.status === "COMPLETED") {
        secureLocalStorage.setItem("__orderconfirmData", response.data);
        setSuccessMsg(true);
      } else {
        setErrorMsg(response.data);
      }
    } catch (error) {
      setErrorMsg(error.response.data);
      setTimerStatus(true);
      // console.error("Error validating status:", error);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="bodly mt-32 text-center">
        {errorMsg === "Error" ? (
          <>
            <PaymentFailed
              goToPage={goToPage}
              setTimer={setTimer}
              timer={timer}
            />
          </>
        ) : (
          errorMsg &&
          (errorMsg?.status && errorMsg.credits ? (
            <main className="inner-pages">
              <h3>{errorMsg?.status}</h3>
              {errorMsg.credits && (
                <h5>
                  Transaction Amount: {errorMsg?.currency} {errorMsg?.credits}
                </h5>
              )}
              <h3 style={{ marginTop: "10px", color: "red" }}>
                {errorMsg?.message}
              </h3>

              <p
                style={{
                  color: "black",
                  textDecoration: "underline",
                  marginTop: "60px",
                  cursor: "pointer",
                }}
                onClick={() => goToPage(null, null, "final.php")}
              >
                Try Again
              </p>
              <p
                style={{
                  marginTop: "40px",
                  textDecoration: "underline",
                  color: "blue",
                  cursor: "pointer",
                }}
                onClick={() => setTimer(0)}
              >
                Go Back({timer})
              </p>
            </main>
          ) : (
            <PaymentFailed
              goToPage={goToPage}
              setTimer={setTimer}
              timer={timer}
            />
          ))
        )}
        {successMsg && (
          <main className="inner-pages">
            <h3 style={{ color: "green" }}>Payment Success</h3>
            <h3 style={{ marginTop: "10px", color: "green" }}>
              {"Your last transaction  go through successfully."}
            </h3>
            <p
              style={{
                marginTop: "40px",
                textDecoration: "underline",
                color: "blue",
                cursor: "pointer",
              }}
              onClick={() => setTimer(0)}
            >
              Go Forward({timer})
            </p>
          </main>
        )}
      </div>
    </div>
  );
};

export default CallBackPayment;

const PaymentFailed = ({ goToPage, setTimer, timer }) => {
  return (
    <section className="flex items-center justify-center   py-8 px-6">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <div className="flex items-center justify-center mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-16 h-16 titlecolo"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 8v4m0 4h.01M12 2a10 10 0 11-10 10A10 10 0 0112 2z"
            />
          </svg>
        </div>
        <h2 className="text-center text-2xl font-semibold title mb-4">
          Payment Failed
        </h2>
        <p className="text-center text-gray-600 mb-4">
          Unfortunately, your payment could not be processed. Please check your
          payment method or try again later.
        </p>
        <div className="text-center">
          <button
            className="bottonlyac bottontex text-white px-6 py-2 rounded-full hover:bg-orange-700 focus:outline-none mt-10"
            onClick={() => goToPage(null, null, "final.php")}
          >
            Try Again
          </button>
          <p
            className="mt-2 underline text-gray-400 cursor-pointer"
            onClick={() => setTimer(0)}
          >
            Go Back in ({timer}) sec
          </p>
        </div>
      </div>
    </section>
  );
};
